exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".static-pages-list {\n  margin-top: 20px; }\n  .static-pages-list .custom-table {\n    margin-top: 0 !important; }\n\n@media only screen and (max-width: 600px) {\n  .static-pages-list .custom-table {\n    margin-top: 20px; }\n  .static-page-detail {\n    margin-top: 10px !important;\n    max-height: calc(100vh - 250px) !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/static_pages/index.scss
// module id = 1591
// module chunks = 0